import { DeviceType } from '@/features/ipad-configs/enums';
import { getDeviceTypeLabel } from '@/features/ipad-configs/utils';
import { IOption } from '@/interfaces';

export const DEVICE_TYPE_OPTIONS: IOption[] = [
  {
    label: getDeviceTypeLabel(DeviceType.NotInUse),
    value: DeviceType.NotInUse.toString(),
  },
  {
    label: getDeviceTypeLabel(DeviceType.OfficeCheckIn),
    value: DeviceType.OfficeCheckIn.toString(),
  },
  {
    label: getDeviceTypeLabel(DeviceType.MeetingRoom),
    value: DeviceType.MeetingRoom.toString(),
  },
  {
    label: getDeviceTypeLabel(DeviceType.ProjectRoom),
    value: DeviceType.ProjectRoom.toString(),
  },
];

export const IPAD_CONFIG_REMARKS_MAX_LENGTH = 2500;
export const IPAD_CONFIG_PROJECT_NAME_MAX_LENGTH = 250;
